// eslint-disable-next-line no-restricted-imports
import { Tooltip } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const HintTooltipStyled = styled(Tooltip)(() => ({
  maxWidth: 504,
  [Tooltip.classes.tooltip.css]: {
    backgroundColor: Colors.blue200,
    color: Colors.black,
    padding: 16,
    borderRadius: 12,
    marginTop: 8,
    maxWidth: 600,
  },

  [Tooltip.classes.arrow.css]: {
    color: Colors.blue200,
  },
}));
